import React from 'react';
import axios from 'axios';
import { user_token } from '../../../../services/Auth';

var token = localStorage.getItem(user_token);

export default class GetUserID extends React.Component {
  state = {
    nome: [],
  }

  componentDidMount() {
    axios.get(`http://api-convida.herokuapp.com/user?_id=${this.props.user_id}`, {headers: {'x-access-token': token}})
      .then(res => {
        const nome = res.data;
        console.log(this.props.user_id);
        this.setState({ nome });
      })
  }

  render() {
    return (
      <ul>
        { this.state.nome.map(person => 
          <span> {person.name} </span>)}
      </ul>
    )
  }
}